import script from "./KTabPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./KTabPanel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanels,QTabPanel});
